export default {
  name: 'AlertNotifications',

  computed: {
    isVisible() {
      return !!this.msg;
    },
  },

  props: {
    msg: String,
  },
};
